var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseService, AuthorizationType } from './base.service';
import { Constants } from '../../models/constants.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../authorization.service";
import * as i3 from "../message.service";
import * as i4 from "../cache.service";
var RoomPublicService = /** @class */ (function (_super) {
    __extends(RoomPublicService, _super);
    function RoomPublicService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpointUri = 'RoomReservation/Rooms';
        return _this;
    }
    Object.defineProperty(RoomPublicService.prototype, "authorizationType", {
        get: function () {
            return AuthorizationType.Anonymous;
        },
        enumerable: true,
        configurable: true
    });
    RoomPublicService.prototype.getAll = function () {
        throw new Error('Method not implemented.');
    };
    RoomPublicService.prototype.get = function (id) {
        return this.getRequest(id);
    };
    RoomPublicService.prototype.add = function (entity) {
        throw new Error('Method not implemented.');
    };
    RoomPublicService.prototype.update = function (entity) {
        throw new Error('Method not implemented.');
    };
    RoomPublicService.prototype.delete = function (id) {
        throw new Error('Method not implemented.');
    };
    RoomPublicService.prototype.getRooms = function (parameters) {
        return this.getAllRequest(this.endpointUri, parameters);
    };
    RoomPublicService.prototype.getOccupancies = function (parameters) {
        return this.getAllRequest(this.endpointUri + '/Occupancies', parameters);
    };
    /**
     * Get TimeSlots (Slot available according to Ressourcenkalender)
     *
     * @param {number} idRessource
     * @param {number} from (unixtime)
     * @param {number} to (unixtime)
     * @returns {Observable<any>}
     * @memberof RoomPublicService
     */
    RoomPublicService.prototype.getTimeSlots = function (idRessource, from, to) {
        return this.getAllRequest(this.endpointUri + '/' + String(idRessource) + '/TimeSlots', [
            { key: Constants.UrlParams.DateFrom, value: String(from) },
            { key: Constants.UrlParams.DateTo, value: String(to) }
        ]);
    };
    RoomPublicService.ngInjectableDef = i0.defineInjectable({ factory: function RoomPublicService_Factory() { return new RoomPublicService(i0.inject(i1.HttpClient), i0.inject(i2.AuthorizationService), i0.inject(i3.MessageService), i0.inject(i4.CacheService)); }, token: RoomPublicService, providedIn: "root" });
    return RoomPublicService;
}(BaseService));
export { RoomPublicService };
